export default __webpack_public_path__ + "static/media/Ellipse 4.18922103.png";